<template>
  <div>
    <div class="container-fluid bg-white py-3">
      <div class="row">
        <div class="col-12">
          <h1 class="mb-0">Create New Producer</h1>
        </div>
      </div>
    </div>

    <div class="container-fluid">
      <div class="row mk-businessinformation pt-3 mt-4">
        <div class="col-12 col-md-6 bg-white mx-auto pt-5 pb-3 d-flex justify-content-between align-items-center">
          <h2 class="mb-0">Producer Details</h2>
          <p class="mb-0">Step 1</p>
        </div>
      </div>

      <div class="row">
        <div class="col-12 col-md-6 bg-white mx-auto py-3">
          <hr />
        </div>
      </div>


      <div class="row">
        <div class="col-12 col-md-6 mx-auto bg-white py-3">
          <el-form :model="business" label-position="left" label-width="150px"
            class="w-100 mx-auto row flex-column justify-content-center" :rules="rules" ref="ruleForm">
            <el-form-item label="Agency" prop="agency_id" v-if="agencies && agencies.length > 0">
              <el-select class="w-100" v-model="business.agency_id" placeholder="Select Agency" filterable>
                <el-option v-for="item in agencies" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="Business Type" prop="business_type_id">
              <el-select v-model="business.business_type_id" class="w-100" placeholder="Select">
                <el-option v-for="item in business_types" :key="item.value" :label="item.name"
                  :value="item.id"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="Name" prop="name">
              <el-input v-model="business.name"></el-input>
            </el-form-item>

            <el-form-item label="ABN" prop="abn">
              <el-input class="w-100" v-model="business.abn"></el-input>
            </el-form-item>

            <el-form-item label="ACN" prop="acn">
              <el-input class="w-100" v-model="business.acn"></el-input>
            </el-form-item>

            <el-form-item label="Property Name">
              <el-input class="w-100" v-model="business.property_name"></el-input>
            </el-form-item>
            <el-form-item label="Warehouse" prop="warehouse_id">
              <el-select class="w-100" v-model="business.warehouse_id" placeholder="Select Warehouse">
                <el-option v-for="item in warehouses" :key="item.value" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
            <div>
              <address-not-found
                @update="updateAddress"
                :data="{
                  not_found: not_found,
                  address: enter_address,
                }"
                :layout="2"
              ></address-not-found>
            </div>
            <el-form-item label="Address" prop="address" class="mb-0 mt-4" v-if="!not_found">
              <div class="row">
                <div class="form-group col-12">
                  <google-maps-autocomplete class="w-100" :value="business.address"
                    v-on:address-components="saveAddresses" @coordinates="saveCoordinates"
                    placeholder="10 Street Name" />
                </div>
                <div v-if="business.lng && business.lat" class="form-group mt-0 col-12 d-flex justify-content-around">
                  <span>Lng: {{ business.lng }}</span>
                  <span>Lat: {{ business.lat }}</span>
                </div>
              </div>
            </el-form-item>
            <div class="row" v-if="!not_found">
              <div class="col-2">
              </div>
              <div class="col-10">
                <button class="btn btn-link" @click.prevent="businessOpenMap = !businessOpenMap">Open Maps</button>
                <draggable-map v-show="businessOpenMap" @dropped-pin="useLocation($event, business)"
                  autocomplete-placeholder="Find an address" :longtitude="Number(business.lng) || undefined"
                  :latitude="Number(business.lat) || undefined" />
              </div>
            </div>

            <div class="row">
              <div class="col-md-12">
                <hr />
              </div>
            </div>

            <div>
              <div class="form-group row">
                <div class="col-md-12">
                  <h5>Guarantors</h5>
                </div>
              </div>

              <el-form :model="guarantor" v-for="(guarantor, index) in business.guarantors" :key="index"
                :rules="guarantorRules" label-position="left" ref="customer-forms" label-width="120px"
                class="w-100 mx-auto row flex-column justify-content-center">
                <div class="row my-3">
                  <div class="col-12 d-flex justify-content-between">
                    <p><strong>Guarantor {{ index + 1}}</strong></p>
                    <a href="#" class="text-red" @click.prevent="removeGuarantor(guarantor, index)"><i
                        class="far fa-times"></i></a>
                  </div>
                </div>

                <el-form-item label="First Name" prop="first_name">
                  <el-input class="w-100" :controls="false" v-model="guarantor.first_name"></el-input>
                </el-form-item>

                <el-form-item label="Last Name" prop="last_name">
                  <el-input class="w-100" :controls="false" v-model="guarantor.last_name"></el-input>
                </el-form-item>

                <el-form-item label="Email" prop="email">
                  <el-input class="w-100" :controls="false" v-model="guarantor.email"></el-input>
                </el-form-item>

                <el-form-item label="Date of Birth" prop="date_of_birth">
                  <el-date-picker v-model="guarantor.date_of_birth" value-format="yyyy-MM-dd" format="dd/MM/yyyy"
                    type="date" class="w-100" placeholder="Pick a day"></el-date-picker>
                </el-form-item>

                <el-form-item label="Address" prop="extra_attributes.address">
                  <google-maps-autocomplete v-if="!guarantor.useBusinessAddress" class="form-control"
                    v-on:address-components="getGuarantorAddress($event, guarantor)"
                    placeholder="10 Street Name.."></google-maps-autocomplete>

                  <el-input v-else class="w-100" :value="guarantor.extra_attributes.address.name" disabled
                    placeholder="10 Street Name"></el-input>
                </el-form-item>
                <el-checkbox v-model="guarantor.useBusinessAddress" @change="copyBusinessAddress($event, guarantor)"
                  :disabled="!business.extra_attributes.address.name">Use Business Address</el-checkbox>


                <div class="row">
                  <div class="col-md-12">
                    <hr />
                  </div>
                </div>
              </el-form>

              <div class="row">
                <div class="col-12 d-flex justify-content-end">
                  <el-button style="margin-top: 12px;" @click="addGuarantor" type="secondary">Add Guarantor</el-button>
                </div>
              </div>
            </div>

            <div class="form-group row">
              <div class="col-md-12 d-flex justify-content-end">
                <el-button style="margin-top: 12px;" @click="onNext" type="primary">Next step</el-button>
              </div>
            </div>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>



<script>
import Business from "../../../models/Business";
import AddressNotFound from "../../../../common/AddressNotFound.vue";

export default {
  components: { AddressNotFound },
  props: {
    business_types: {
      type: Array
    },
    warehouses: {
      type: Array
    },
    agencies: {
      type: Array
    },
    initial_business: {
      type: Business
    }
  },
  data() {
    return {
      useBusinessAddress: false,
      business: this.initial_business,
      businessOpenMap: false,
      rules: {
        name: [
          {
            required: true,
            message: "Please choose a name",
            trigger: "blur"
          }
        ],
        business_type_id: [
          {
            required: true,
            message: "Please choose a business type",
            trigger: "change"
          }
        ],
        dollar_finance_capacity: [
          {
            required: false,
            message: "Please choose a finance amount",
            trigger: "blur"
          }
        ],
        bsb: [
          {
            required: false,
            message: "Please choose a BSB",
            trigger: "blur"
          }
        ],
        account_number: [
          {
            required: false,
            message: "Please choose a account number",
            trigger: "blur"
          }
        ],
        communication_preference: [
          {
            required: false,
            message: "Please select communication preference",
            trigger: "change"
          }
        ],
        warehouse_id: [
          {
            required: true,
            message: "Please choose a warehouse",
            trigger: "change"
          }
        ],
        agency_id: [
          {
            required: true,
            message: "Please choose a agency",
            trigger: "change"
          }
        ],
      },
      guarantorRules: {
        first_name: [
          {
            required: true,
            message: "Please choose a first name",
            trigger: "blur"
          }
        ],
        last_name: [
          {
            required: true,
            message: "Please choose a last name",
            trigger: "blur"
          }
        ],
        email: [
          {
            required: true,
            type: "email",
            message: "Please choose a valid email",
            trigger: "blur"
          }
        ]
      },
      not_found:false,
      enter_address: {
        administrative_area_level_1: null,
        formatted_address: null,
        locality: null,
        postal_code: null,
        unit_number: null,
      },
    };
  },
  methods: {
    updateAddress(data) {
      this.not_found = data.not_found;
      this.enter_address = data.address;
    },
    saveAddresses(payload) {
      this.business.extra_attributes.address = payload;
      this.business.address = payload.formatted_address;
      this.business.extra_attributes.address.formatted_address = payload.formatted_address;
    },
    saveCoordinates(payload) {
      this.business.lng = payload.lng;
      this.business.lat = payload.lat;
    },
    useLocation(value, target) {
      if (!target.extra_attributes.address) target.extra_attributes.address = {};
      target.address = value.google_address.formatted_address;
      target.extra_attributes.address.name = value.google_address.formatted_address;
      target.extra_attributes.address.lat = value.location.lat;
      target.extra_attributes.address.lng = value.location.lng;
      target.lat = value.location.lat;
      target.lng = value.location.lng;

      value.google_address.address_components.forEach(x => {
        let type = x.types[0];
        target.extra_attributes.address[type] = x.short_name;
      })

      // find unit
      if (value.google_address.address_components[0].types.find(type => type == 'subpremise')) {
        target.extra_attributes.address.unit_number = value.google_address.address_components[0].short_name;
      }
    },
    onNext() {
      let passes = true;
      if (this.$refs["customer-forms"]) {
        for (let i = 0; i < this.$refs["customer-forms"].length; i++) {
          this.$refs["customer-forms"][i].validate(valid => {
            if (!valid) {
              passes = false;
            }
          });
        }
      }

      this.$refs["ruleForm"].validate(valid => {
        if (valid && passes) {
          if (this.not_found) {
            this.business.extra_attributes = {
              address: this.enter_address,
            };
          }
          console.log(this.business)
          this.$emit("next", this.business);
        } else {
          this.$message({
            type: "error",
            message: "Looks like there was some invalid data."
          });
          return false;
        }
      });

    },
    addGuarantor() {
      this.business.guarantors.push({
        first_name: null,
        last_name: null,
        phone: null,
        email: null,
        acn: null,
        company_name: null,
        extra_attributes: {
          address: {
            unit_number: null
          },
        }
      })
    },
    removeGuarantor(value, index) {
      this.business.guarantors.splice(index, 1);
    },
    getAddressData: function (addressData, placeResultData, id) {
      if (this.business.extra_attributes.address.unit_number) {
        business.unit_number = this.business.extra_attributes.address.unit_number;
      }
      this.business.extra_attributes.address = addressData;
    },
    getGuarantorAddress(addressData, guarantor) {
      let unitNumber = guarantor.extra_attributes.address.unit_number || null;
      guarantor.extra_attributes.address = addressData;
      guarantor.extra_attributes.address.unit_number = unitNumber;
    },
    copyBusinessAddress(event, guarantor) {
      guarantor.extra_attributes.address.name = event ? this.business.extra_attributes.address.name : '';
    }
  },
  computed: {
    isSoleTrader() {
      const type = this.business_types.find(type => type.id == this.business.business_type_id);
      if (type && type.name == 'Sole Trader') {
        return true;
      }
      return false;
    }
  }
};
</script>

<style scoped>
label {
  margin-top: 0.5rem;
}
</style>